import React from 'react';
import ForgotPasswordFormLayout01 from './layout_01/ForgotPasswordFormLayout';
import ForgotPasswordFormLayout02 from './layout_02/ForgotPasswordFormLayout';
import { useAppSelector } from '../../store/hook';
import { getTemplateLayout } from '../../common/utils/fallbackCondition';

export interface ForgotPasswordFormProps {
  labelKey: 'email' | 'username';
  value: string;
  placeholderKey?: string;
  helperText: string;
  alert: { state: 'error' | 'info'; message: string };
  loading: boolean;
  cancelRoutePath: string;
  locked?: true;
  isJourneyLayout?: boolean;
  inputChangeHandler(name: string): (event: React.ChangeEvent<{ value: string }>) => void;
  onResetPasswordClick(event: React.SyntheticEvent): Promise<void>;
  alertRef?: React.RefObject<HTMLDivElement>;
}

/** Component for Forgot Password Form */
export const ForgotPasswordForm = ({
  value,
  placeholderKey,
  helperText,
  labelKey,
  cancelRoutePath,
  locked,
  inputChangeHandler,
  onResetPasswordClick,
  alert,
  loading,
  alertRef,
}: ForgotPasswordFormProps): React.JSX.Element => {
  const template = useAppSelector((state) => state.template);
  const { layoutCode } = template;

  const ForgotPasswordLayoutMap: { [key: string]: React.FC<ForgotPasswordFormProps> } = {
    TEMPLATE_LAYOUT_01: ForgotPasswordFormLayout01,
    TEMPLATE_LAYOUT_02: ForgotPasswordFormLayout02,
    TEMPLATE_LAYOUT_03: ForgotPasswordFormLayout01,
  };

  const layout = getTemplateLayout(layoutCode);
  return (
    <>
      {React.createElement(ForgotPasswordLayoutMap[layout], {
        value,
        placeholderKey,
        helperText,
        labelKey,
        cancelRoutePath,
        locked,
        inputChangeHandler,
        onResetPasswordClick,
        alert,
        loading,
        alertRef,
      })}
    </>
  );
};
